import { useViewport } from '@xyflow/react'
import type { Segment } from './snap'

/**
 * The alignment lines and equal-gap marks while something is dragged
 * (snap.ts). On the screen, in the selection's blue, a hairline at any zoom;
 * a component of its own so following the board re-draws only these.
 */
export function SnapGuides({ lines, gaps }: { lines: Segment[]; gaps: Segment[] }) {
  const { x, y, zoom } = useViewport()
  const at = (s: Segment) => ({
    x1: s.x1 * zoom + x,
    y1: s.y1 * zoom + y,
    x2: s.x2 * zoom + x,
    y2: s.y2 * zoom + y,
  })
  return (
    <svg className="csnap" aria-hidden="true">
      {lines.map((line, index) => (
        <line key={`l${index}`} {...at(line)} className="csnap__line" />
      ))}
      {gaps.map((gap, index) => {
        const g = at(gap)
        const flat = Math.abs(g.y1 - g.y2) < 0.5
        // Short ends across the span, so it reads as a measurement.
        const e = 5
        return (
          <g key={`g${index}`} className="csnap__gap">
            <line {...g} />
            {flat ? (
              <>
                <line x1={g.x1} y1={g.y1 - e} x2={g.x1} y2={g.y1 + e} />
                <line x1={g.x2} y1={g.y2 - e} x2={g.x2} y2={g.y2 + e} />
              </>
            ) : (
              <>
                <line x1={g.x1 - e} y1={g.y1} x2={g.x1 + e} y2={g.y1} />
                <line x1={g.x2 - e} y1={g.y2} x2={g.x2 + e} y2={g.y2} />
              </>
            )}
          </g>
        )
      })}
    </svg>
  )
}
